export const DEFAULT_PLATFORM_ORIGIN = "https://netapp.aesoft.co";
export const ORIGIN_STORAGE_KEY = "n1-platform-origin";

export function normalizePlatformOrigin(input: string) {
  const trimmed = input.trim();
  if (!trimmed) throw new Error("Укажите адрес сервера.");
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed) && !/^https?:/i.test(trimmed)) {
    throw new Error("Адрес сервера должен начинаться с http:// или https://.");
  }
  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  let url: URL;
  try {
    url = new URL(withScheme);
  } catch {
    throw new Error("Адрес сервера не похож на ссылку.");
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") {
    throw new Error("Адрес сервера должен начинаться с http:// или https://.");
  }
  if (url.username || url.password) {
    throw new Error("В адресе сервера не должно быть логина и пароля.");
  }
  return url.origin;
}

export function originHost(value: string) {
  try {
    return new URL(value).host;
  } catch {
    return value;
  }
}
